import config from '../config';
import {
  removeWorker,
  removeShop,
  loadShops,
  loadWorkersByShop,
  loadUnassignedWorkers,
  loadShopLeads,
  loadShop,
  addShop,
  updateShop,
  checkShopUnique
 } from '../actions/shops';
import fetch from 'cross-fetch';
import store from 'store2';
import { addNotification as notify } from 'reapop';
import { push } from 'react-router-redux';

export function removeWorkerById(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/shop/deleteWorker/${data.id}`, {
          method: 'DELETE',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(removeWorker({ id: data.id }));
            dispatch(notify({
              title: 'Worker has removed',
              message: 'Worker removed successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
    }
  }
}

export function removeShopById(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/shop/${data.id}`, {
          method: 'DELETE',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(removeShop({ id: data.id }));
            dispatch(notify({
              title: 'Shop has removed',
              message: 'Shop removed successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
    }
  }
}

export function fetchShops() {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/shop`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          dispatch(loadShops({ list: json }));
        })
    }
  }
}

export function loadWorkersByShopId(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/shop/getWorkers/${id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(loadWorkersByShop({ workers: json }));
          }
        })
    }
  }
}

export function fetchUnassignedWorkers(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/shop/getUWorkers`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(loadUnassignedWorkers({ unassignedWorkers: json }));
          }
        })
    }
  }
}

export function fetchShopLeads(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/shop/getShopLeads/${id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(loadShopLeads({ shopLeads: json }));
          }
        })
    }
  }
}

export function fetchShopById(id) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/shop/${id}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(loadShop({ shop: json }));
          }
        })
    }
  }
}

export function createShop(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/shop`, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(addShop({ shop: json }));
            dispatch(push('/pages/shops'));
            dispatch(notify({
              title: 'Add New Shop',
              message: 'Shop added successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Add New Shop',
            message: 'Failed to add new shop',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
}

export function updateShopById(id, data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/shop/${id}`, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(push('/pages/shops'));
            dispatch(updateShop({ shop: json }));
            dispatch(notify({
              title: 'Edit Shop',
              message: 'Shop edited successfully',
              status: 'success',
              position: 'tr',
              dismissible: true,
              dismissAfter: 3000
            }));
          }
        })
        .catch(response => {
          dispatch(notify({
            title: 'Edit Shop',
            message: 'Failed to edit shop',
            status: 'error',
            position: 'tr',
            dismissible: true,
            dismissAfter: 3000
          }));
        });
    }
  }
}

export function checkShopUniqueById(data) {
  return (dispatch) => {
    const userAuth = store.get('user');
    if (userAuth && userAuth.api_token) {
      return fetch(`${config.apiEndpoint}/shop/isUniqueName/${data.id}`, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${userAuth.api_token}`
          },
          credentials: 'same-origin'
        })
        .then((response) => {
          return response.json();
        })
        .then(json => {
          if (json) {
            dispatch(checkShopUnique({ shop: json }));
          }
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/shops.js